import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-enquadramento-legal-edit',
  templateUrl: './enquadramento-legal-edit.component.html',
  styleUrls: ['./enquadramento-legal-edit.component.css'],
  standalone: false
})
export class EnquadramentoLegalEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/enquadramento-legal`;

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'CAT 83/2009' },
      { label: 'Dados de Processamento' },
      { label: 'Configurações' },
      { label: 'Enquadramento Legal', link: '/enquadramento-legal' },
      { label: 'Edição Enquadramento Legal' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
    save: 'enquadramento-legal',
  };

  fields: PoPageDynamicEditField[] = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('enquadramento-legal').subscribe((data) => {
      this.fields = data;
    });
  }
}
